export const environment = {
    urlglobal: 'https://api-merchants.payvalida.com',
    production: true,
    urlglobal_api: 'https://api.payvalida.com',
    host: 'https://secure-checkout.payvalida.com/',
    avvillas: 'VALIDDA2019',
    pseav: 'https://www.pagosvirtualesavvillas.com.co/personal/pagos/pagar',
    captchaKey: '6LfjyNEUAAAAANNya349DKHXAsd2a2-ecagDscFd',
    rollbarId: '30fdddd6677c4aeaab06b70dac21208d',
    rollbarEnv: 'prod',
    features: {
        getMethodsPay: true,
    },
    timer3dsInit: 3000,
    timer3dsFinal: 5000,
    ld_api_checkout: '62c744053dbf0514fd817c6c',
    feature_flag_name: 'checkout_FF',
    infoEmail: 'info@payvalida.com',
    support_email: 'support@payvalida.com',
    redirect_bnpl: 'https://bnpl-bancolombia.payvalida.com/onboarding',
    logo_bn_cr: 'https://images.payvalida.com/logo_medio_recaudo/CR/Logo%20Banco%20Nacional%20-%20BN%20Servicios.png',
    logo_bcr: 'https://images.payvalida.com/logo_medio_recaudo/CR/costarica.png',
    payvalidaPhone: 3117083644,
    minimum_value_bnpl: 100000,
    maximum_value_bnpl: 3000000,
    minimumValueBnpl: 100000,
    terms_conditions_url: 'https://docs.payvalida.com/documentacion-legal/terminos-y-condiciones',
    policy_data_url: 'https://docs.payvalida.com/documentacion-legal/manual-de-politicas-y-procedimientos',
    webSocketApi: '',
    payvalida_nit: '900418685',
    urlWalletSignUp: 'https://wallet.payvalida.com/signupPage',
    urlWalletRecoverPass: 'https://wallet.payvalida.com/recoverPasswordPage',
    urlWalletLogin: 'https://wallet.payvalida.com/loginPage',
    urlWallet: 'https://wallet.payvalida.com',
    urlTcImage: 'https://images.payvalida.com/credit_card_form/logotc.png',
    ld_bnpl_group: '643d5a82ce62f1138b38cb53',
    info_email_co: 'info.co@payvalida.com',
    bancolombia_phone: 'xxxxx',
    min_value_consumer_credit: 1000000,
    redirect_cdc: 'https://cl-bancolombia.payvalida.com/onboarding',
    logo_bam_gu: 'https://images.payvalida.com/logo_medio_recaudo/GU/bam.png',
    logo_bi_gu: 'https://images.payvalida.com/logo_medio_recaudo/GU/bancoindustrial.png',
    ref_bam: '542 a nombre de Payvlida Guatemala S.A',
    info_cr_payvalida_email: 'info.cr@payvalida.com',
    info_cr_payvalida_whatsapp_number: '51920004715',
    whatsapp_logo: 'https://images.payvalida.com/mailing/merchant/whatsappicono.png',
    logo_yape: 'https://images.payvalida.com/logo_medio_recaudo/PE/Logo_Yape_CheckOut_Payvalida.png',
    urlCheckoutGuide: 'https://r.payvalida.com/checkout-instructions/guia-checkout',
    ptosHeyLocationsPdf: 'https://r.payvalida.com/checkout/listado-puntos-hey',
    logoLafiseBank: 'https://images.payvalida.com/logo_medio_recaudo/CR/logo%20red%20Banco%20Lafise.png',
    payvalidaJsSdk: 'https://3ds.payvalida.com/sdk.min.js',
    modulesPayvalidaUrl: 'https://modules.payvalida.com',
    kountClientID: '102321',
    kountHostname: 'ssl.kaptcha.com',
    kountIsDebugEnabled: false,
    kountEnvironment: 'PROD',
    sentryDsn: 'https://a23ff3a86f0150fb1e29899855b4805d@o4508094557585408.ingest.us.sentry.io/4508094604443648',
};